/*
 * $Id:: index.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { useLocation } from 'react-router-dom';

import LoginPage from '../LoginPage';
import SelfRegistrationPage from '../SelfRegistrationPage';

const useStyles = makeStyles((_theme) => ({
    pageWrapper: {
        display: 'flex',
        flexFlow: 'column nowrap',
    },
    pageItem: {
        flex: '1 1 auto',
    },
    inactivePage: {
        opacity: 0.4,
        pointerEvents: 'none',
    },
}));

const LoginRegisterPage = () => {
    const classes = useStyles();
    const { pathname } = useLocation();
    const splitted = pathname.split('/');

    const routePath = (splitted.length > 1 && splitted[1]) || '';

    const selfRegClass = routePath === 'new-account' ? classes.pageItem : `${classes.pageItem} ${classes.inactivePage}`;
    const loginClass = routePath === 'login' ? classes.pageItem : `${classes.pageItem} ${classes.inactivePage}`;

    return (
        <div className={classes.pageWrapper}>
            {routePath === 'login' && (
                <div className={loginClass}>
                    <LoginPage />
                </div>
            )}
            {routePath === 'new-account' && (
                <div className={selfRegClass}>
                    <SelfRegistrationPage />
                </div>
            )}
        </div>
    );
};

export default LoginRegisterPage;
